<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>RESTABLECIMIENTO DE CONTRASEÑA</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-5 pb-1">

		<h3 class="text-center mt-3">Instrucciones</h3>
		<p>Ingresa la dirección de correo electrónico que usaste para registrarte.<br> Te enviaremos un mensaje con instrucciones sobre cómo restablecer tu contraseña.</p>
		<div class="row mb-5">
			<div class="col-12 mt-3">
				<form #f="ngForm" (ngSubmit)="onSubmit(f)" ngNativeValidate class="pb-3 text-left">
					<div class="row">
						<div class="form-group mb-3 col-sm-12 col-lg-6 col-12 p-0 mx-auto">
                            <label for="email">Correo electrónico</label>
                            <input ngModel name="email" type="email" id="email" required class="form-control">
                        </div>
					</div>
					<div class="col-sm-12 text-center mt-4">
						<button type="submit" class="btn btn-enviar">Enviar</button>
					</div>
				</form>
			</div>
		</div>

		<div class="col-12 alerta blqCtr text-center" *ngIf="this.confirma">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-mail.jpg">
            <p>La nueva contraseña será enviada al correo registrado, si continua su contraseña actual dejará de
                funcionar y tendrá que ingresar con la proporcionada por el sistema, ¿desea continuar?</p>
            <button class="mr-2" (click)="change()"> Confirmar</button>
            <button class="ml-2 greyBtn" (click)="cancel()"> Cancelar</button>
        </div>
        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-mail-bandeja.jpg">
            <p>La contraseña ha sido enviada a su correo electrónico.</p>
            <button class="btn-confirmar" (click)="closeok()">Aceptar</button>
        </div>
        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.fail">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p>Los datos ingresados no están registrados en el sistema, favor de verificarlos o realizar su registro.</p>
            <button class="btn-confirmar" (click)="closeok()">Aceptar</button>
        </div>

	</div>

</div>